<template lang="html">
  <div class="test-group" v-if="group">
    <div class="test-group-title">
      {{ title }}
    </div>
    <div class="test-group-questions" v-if="questions">
      <Question v-for="(question, i) in questionsSorted" :key="i" :question="question" :index="i + 1" :answerChange="answerChange"/>
    </div>
    <div v-else>
      <!-- no questions message -->
    </div>
  </div>
</template>

<script>
  import Question from './Question.vue'

  export default {
    name: 'interview-test-group',

    components: {
      Question
    },

    props: {
      group: Object,
      answerChange: Function
    },

    data () {
      return {
      }
    },

    methods: {
    },

    computed: {
      title () {
        return this.group ? this.group.title : void 0
      },

      questions () {
        return this.group.questions ? this.group.questions : void 0
      },

      questionsSorted () {
        return this.questions.map(item => item).sort((a, b) => a.priority - b.priority)
      }
    },

    beforeMount () {
    }
  }
</script>

<style lang="scss" scoped>
  .test-group {
    padding: 32px 0px;
    .test-group-title {
      font-size: 1.5em;
      font-weight: 700;
    }
  }
</style>
